import _isFunction from 'lodash/isFunction'
import { createRoot } from 'react-dom/client'

// eslint-disable-next-line no-undef
const Component = videojs.getComponent('Component')
const COMPONENT_NAME = 'VideoPlayerApp'

export const PLUGIN_NAME = 'VideoPlayerApps'

function VideoPlayerApps (options = {}) {
  const { render } = options
  if (!_isFunction(render)) {
    throw new Error('The render option is required to be a function')
  }

  this.ready(function onPlayerReady () {
    const player = this
    let root
    let attempt = 0
    const videoJsComponent = player.addChild(COMPONENT_NAME)
    // Wait until the player has loaded then component has loaded to create the react app
    const intervalId = player.setInterval(() => {
      const domElement = videoJsComponent.el()
      attempt += 1
      if (!domElement) {
        if (attempt > 10) {
          player.clearInterval(intervalId)
        }
        return
      }
      const component = render(player)
      // Create the React app
      root = createRoot(domElement)
      root.render(component)
      player.clearInterval(intervalId)
    }, 100)
    videoJsComponent.one('dispose', () => {
      player.setTimeout(() => {
        // since this is taken out of the main thread
        // we want to check if root still exists here...
        if (root && root.unmount) {
          root.unmount()
          root = undefined
        }
      }, 0)
    })
  })
}

class VideoPlayerApp extends Component {}

export function register (videojs = window.videojs) {
  videojs.registerComponent(COMPONENT_NAME, VideoPlayerApp)
  videojs.registerPlugin(PLUGIN_NAME, VideoPlayerApps)
}
